meedy.controller('meedy.calendarListController', ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$mdDialog',
    'meedyConfig', 'meedy.objectHelper', 'meedy.baseModel', 'meedy.applicationModel', 'meedy.resourceDetailsModel', 'meedy.availabilityRuleModel',
    'meedy.termModel',
    function ($rootScope, $scope, $state, $stateParams, $translate, $mdDialog, config, objectHelper, baseModel, applicationModel,
              resourceDetailsModel, availabilityRuleModel, termModel) {

        var listeners = {};

        function setData() {
            $scope.today = new Date();
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 100000;

            $scope.availabilityRuleRange = objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                startDate: moment($scope.today).startOf('week').toDate(),
                endDate: moment($scope.today).endOf('week').toDate()
            });
            $scope.selectedRow = null;

            $scope.vm = {
                selectedResourceAvailabilities: []
            }

        }

        function setPermissions() {
        }

        function setListeners() {
            listeners.onDoctorsLoad = function (doctorList) {
                //$scope.selectedResource = null;
                $scope.selectedRow = null;
                $scope.doctorList = doctorList.data;
                $scope.fullDoctorList = doctorList.data;
            };

            listeners.onNearestAvailabilityLoad = function (nearestAvailabilities) {
                $scope.vm.selectedResourceAvailabilities = nearestAvailabilities;
            };

            listeners.onTakenTermsLoad = function (data) {
                $scope.takenTerms = data;
            };

        }

        function setActions() {
            $scope.getData = function() {

            };

            $scope.selectResource = function (res, idx) {
                $scope.availabilityRuleRange = objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                    startDate: moment($scope.today).startOf('week').toDate(),
                    endDate: moment($scope.today).endOf('week').toDate()
                });
                //$scope.selectedResource = null;

                if(!!res.id) {
                    $scope.availabilityRuleRange.idResourceDetails = res.id;
                } else {
                    $scope.availabilityRuleRange.idResource = res.resources[0].id;
                }
                availabilityRuleModel.getNearestAvailabilityRuleCacheOccurrenceForAbc($scope.availabilityRuleRange).then(function(data) {
                    listeners.onNearestAvailabilityLoad(data);
                    $scope.selectedRow = idx;
                    //$scope.selectedResource = res;
                });
            };

            $scope.hideResourceCalendar = function () {
                $scope.selectedRow = null;
            };

            $scope.criteriaChangedForCalendar = function(criteria) {
                availabilityRuleModel.getNearestAvailabilityRuleCacheOccurrenceForAbc($scope.availabilityRuleRange).then(listeners.onNearestAvailabilityLoad);
            };
            
            $scope.onSearchPhraseChanged = function () {
                $scope.selectedRow = null;

                $scope.doctorList = $scope.fullDoctorList.filter(function(doctor) {
                    var searchPhrase = $scope.criteria.searchPhrase.toLowerCase();

                    var foundInDoctor = (doctor.fullName.toLowerCase().indexOf(searchPhrase) !== -1);
                    var foundInResources = (doctor.resources.length && doctor.resources.some(function(resource) {
                        return (
                            (resource.name.toLowerCase().indexOf(searchPhrase) !== -1) ||
                            (resource.address && resource.address.city.toLowerCase().indexOf(searchPhrase) !== -1) ||
                            (resource.address && resource.address.street.toLowerCase().indexOf(searchPhrase) !== -1) ||
                            (resource.firstName && resource.firstName.toLowerCase().indexOf(searchPhrase) !== -1) ||
                            (resource.lastName && resource.lastName.toLowerCase().indexOf(searchPhrase) !== -1)
                        )
                    }));

                    return (foundInDoctor || foundInResources);
                })
            };
        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.fillViewportMode = true;

            resourceDetailsModel.getDataPageForCalendar($scope.criteria).then(listeners.onDoctorsLoad);

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
